import React from 'react';
import { styled } from '@mui/system';
import Switch from '@mui/material/Switch';
import { getContrastColor } from '#component/theme';

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: theme.spacing(1),
  '& .MuiSwitch-switchBase': {
    padding: '1px !important',
    color: `${theme.palette.common.white} !important`,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        backgroundColor: getContrastColor(),
        opacity: 1,
        border: 'none'
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.secondary.main,
      border: '6px solid #fff'
    }
  },
  '& .MuiSwitch-thumb': {
    width: 24,
    height: 24
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  }
}));

export default props => (
  <StyledSwitch disableRipple {...props} />
);
